import Vue from 'vue';
import { find } from 'lodash';
import LocaleHelper from '@vertical-plus/vue-js-core/dist/util/i18n/locale-helper';
import showdown from 'showdown';
// Instantiate a single markdown converter
const converter = new showdown.Converter();
converter.setFlavor('github');
const MicroServicePlugin = {
    install(Vue) {
        // Define properties
        Object.defineProperties(Vue.prototype, {
            $isEmbedded: {
                get() {
                    var _a;
                    if ((_a = this.$route.query) === null || _a === void 0 ? void 0 : _a.embedded) {
                        sessionStorage.setItem('embedded', 'true');
                    }
                    if (sessionStorage.getItem('embedded')) {
                        return true;
                    }
                    return false;
                },
            },
            $oauthLogin: {
                get() {
                    return this.$store.getters['authentication/oauthLogin'];
                },
            },
            $project: {
                get() {
                    return this.$store.getters['authentication/project'];
                },
                set(project) {
                    this.$store.commit('authentication/project', project);
                },
            },
            $projectSettings: {
                get() {
                    return this.$store.getters['authentication/projectSettings'];
                },
                set(settings) {
                    this.$store.commit('authentication/projectSettings', settings);
                },
            },
            $showTemplate: {
                get() {
                    if (this.$isEmbedded) {
                        return false;
                    }
                    if (!this.$user) {
                        return false;
                    }
                    return true;
                },
            },
            $user: {
                get() {
                    return this.$store.getters['authentication/user'];
                },
            },
            $userSettings: {
                get() {
                    return this.$store.getters['authentication/userSettings'];
                },
                set(settings) {
                    this.$store.commit('authentication/userSettings', settings);
                },
            },
        });
        // Entity translator
        Vue.prototype.$et = (translations) => LocaleHelper.getTranslationForCurrentLocale(translations);
        // Returns whether the user is granted the given role
        Vue.prototype.$isGranted = function (role) {
            var _a;
            if (!((_a = this.$user) === null || _a === void 0 ? void 0 : _a.roles)) {
                return false;
            }
            return this.$user.roles.includes(role);
        };
        // Markdown converter
        Vue.prototype.$markdownToHtml = (markdown) => converter.makeHtml(markdown);
        // Returns a specific project setting
        Vue.prototype.$projectSetting = function (key) {
            const setting = find(this.$projectSettings, { key });
            if (!setting) {
                return null;
            }
            return setting.value;
        };
        // Returns a specific user setting
        Vue.prototype.$userSetting = function (key) {
            const setting = find(this.$userSettings, { key });
            if (!setting) {
                return null;
            }
            return setting.value;
        };
        // Returns the value for a setting taking into account both project and user settings
        Vue.prototype.$setting = function (key) {
            // Prefer the user setting
            const userSetting = this.$userSetting(key);
            if (userSetting !== null) {
                return userSetting;
            }
            // Fallback on the project setting
            return this.$projectSetting(key);
        };
    },
};
Vue.use(MicroServicePlugin);
export default MicroServicePlugin;
//# sourceMappingURL=micro-service.js.map